import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobTeams } from '../../lib';

function Teams(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <>
            <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/teams`}>
                {
                    <MobTeams weId={`${props.weId || ''}__pz7pga`} />
                }
            </Route>
            <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/teams/:showType`}>
                {
                    <MobTeams weId={`${props.weId || ''}__pz7pga`} />
                }
            </Route>
        </>
    )
}

export default withRouter(Teams);